module.exports = __webpack_public_path__ + "img/0Q3A2889_L_BlackMatted_MockedUp.00cf4db9.jpg";